import * as React from "react";
import { useContext } from "react";
import { Dropdown, Form } from "semantic-ui-react";
import { QAPropsBase } from "../State";
import { store, validatorFn, changeFn } from "../store";

// tslint:disable-next-line: interface-name
interface Props {
    index: number;
    propsBase: QAPropsBase;
    onChange?: changeFn;
}

const DropDownAnswer: React.FunctionComponent<Props> = (props: Props) => {
  const globalState = useContext(store);
  const { dispatch } = globalState;

  return (
        <Form.Field fluid required={props.propsBase.isRequired}>
          <Dropdown id={props.index} className="dropdown-answer"
              selection compact style={{ textAlign: "center" }}
            options={props.propsBase.answerContent.split(";").map((a) => {
              const elements = a.split(":");
              return {key: elements[0].substring(0), text: elements[0], value: elements[1]};
            })}
            // tslint:disable-next-line: max-line-length
              onChange={(e, d) => props.onChange ? props.onChange(e,props.index, d) : dispatch({ type: "handle answer update", index: props.index, value: d.value, validator: props.propsBase.answerValidator })}
          />
        </Form.Field>
    );
  };

export default DropDownAnswer;
